var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.datum)?_c('span',{staticClass:"SicherheitsdatenblaetterZuletztVerwendet"},[_c('java-date-to-default-date-format',{model:{value:(_vm.datum),callback:function ($$v) {_vm.datum=$$v},expression:"datum"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }